module.exports = __webpack_public_path__ + "static/media/ayutthaya.b681529c.jpg";